import { Component } from '@angular/core';

@Component({
  selector: 'app-student-counselling-details-landing',
  templateUrl: './student-counselling-details-landing.component.html',
  styleUrls: ['./student-counselling-details-landing.component.scss']
})
export class StudentCounsellingDetailsLandingComponent {

}
